var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconMoreArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "place_icon_more_bg",
    d: "M19 0C29.4933 0 38 8.50672 38 19C38 29.4933 29.4933 38 19 38C8.50672 38 0 29.4933 0 19C0 8.50672 8.50672 0 19 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "place_icon_more_border",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 19C37 9.05901 28.941 1 19 1C9.05901 1 1 9.05901 1 19C1 28.941 9.05901 37 19 37C28.941 37 37 28.941 37 19ZM38 19C38 8.50672 29.4933 0 19 0C8.50672 0 0 8.50672 0 19C0 29.4933 8.50672 38 19 38C29.4933 38 38 29.4933 38 19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "place_icon_more_arrow",
    d: "M26.8535 18.646L20.8535 12.6465L20.1465 13.3536L25.2933 18.5001H11.5V19.5001H25.2924L20.1464 24.646L20.8536 25.3531L26.8536 19.3531C26.9473 19.2593 27 19.1322 27 18.9995C27 18.8669 26.9473 18.7398 26.8535 18.646Z"
  })));
}
export default SvgCommonIconMoreArrow;